import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ClientCredentials } from '../../interfaces';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    constructor(private http: HttpClient) {}

    public login(clientCredentials: ClientCredentials): Observable<any> {
        return this.http.post(`${environment.apiUri}/auth/login`, {
            email: clientCredentials.email,
            password: clientCredentials.password
        });
    }

    public logOut(): Observable<void> {
        return this.http.get<void>(`${environment.apiUri}/auth/logOut`);
    }

    public refreshToken(refreshToken: string): Observable<any> {
        const headers = new HttpHeaders({
            Authorization: `Bearer ${refreshToken}`
        });

        return this.http.get<any>(`${environment.apiUri}/auth/refresh`, { headers });
    }
}
